const authorizedDealer = {
  authorizedDealer: {
    dealerId: 'Autoryzowany podwykonawca',
    city: 'Miasto',
    state: 'Stan',
    country: 'Państwo',
    noDealer: '** Brak dostępnego autoryzowanego podwykonawcy **',
    heading: 'Autoryzowany podwykonawca',
    addDealerButton: '+ Dodaj autoryzowanego podwykonawcę',
    cancel: 'ANULUJ',
    addSubcontractor: 'DODAJ PODWYKONAWCĘ',
    searchContractor: 'WYSZUKAJ PODWYKONAWCĘ',
    show: 'Pokazywanie',
    to: 'do',
    of: 'z',
    delete: 'Usuń',
    name: 'Nazwa',
    enabled: 'Włączone',
    disabled: 'Nieaktywne',
    status: 'Status',
    footer: 'Autoryzowani podwykonawcy'
  }
};

export default authorizedDealer;
